import {
    ChangeDetectorRef,
    Component, EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit, Output,
    SimpleChanges,
    ViewEncapsulation
} from "@angular/core";
import {ButtonSettings} from "./smm.button.types";
import {NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet} from "@angular/common";
import {MatButton, MatFabButton, MatIconButton, MatMiniFabButton} from "@angular/material/button";
import {RouterLink} from "@angular/router";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";
import {WidgetSize} from "../user-card-2/user.card2.component";
import {Subject, takeUntil} from "rxjs";
import {MatIcon} from "@angular/material/icon";

@Component({
    selector     : 'smm-butt',
    templateUrl  : './smm.button.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports: [
        NgSwitch,
        NgSwitchDefault,
        NgSwitchCase,
        MatButton,
        MatIconButton,
        MatFabButton,
        MatMiniFabButton,
        RouterLink,
        MatIcon,
        NgIf,
        NgTemplateOutlet
    ],
})
export class SmmButtonComponent implements OnChanges, OnInit, OnDestroy
{
    @Input() settings:ButtonSettings = {
        text: '',
        color: 'primary',
        primaryMatType: 'raised',
        smallMatType: 'icon',
        routerLink: null,
        auto: true,
        icon: null,
    };
    @Output() clickedEvt = new EventEmitter<string>();
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    text:string;
    type:string;
    currentSize: WidgetSize = WidgetSize.large;


    constructor(
        private breakpointObserver: BreakpointObserver,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {}


    ngOnChanges(changes: SimpleChanges) {
        if (changes.settings?.currentValue) {
            this.settings = changes.settings.currentValue;
            this.reconfigureButton(this.currentSize);
        }
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    ngOnInit(): void {
        if(this.settings){
            this.text = this.settings.text;
            this.type = this.settings.primaryMatType;
        }
        const sizes:{xs:string,sm:string,md:string,lg:string} = {
            xs: "360px", //max
            sm: "600px",
            md: "1024px",
            lg: "1920px"
        }
        // detect screen size changes
        this.breakpointObserver.observe([
            "(max-width: "+sizes.xs+")",
            "(max-width: "+sizes.sm+")",
            "(max-width: "+sizes.md+")"
        ]).pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: BreakpointState) => {
            if (result.breakpoints["(max-width: "+sizes.xs+")"]) {
                this.reconfigureButton(WidgetSize.tiny);
            } else if (result.breakpoints["(max-width: "+sizes.sm+")"]) {
                this.reconfigureButton(WidgetSize.small);
            } else if (result.breakpoints["(max-width: "+sizes.md+")"]) {
                this.reconfigureButton(WidgetSize.medium);
            } else {
                this.reconfigureButton(WidgetSize.large);
            }
            this._changeDetectorRef.markForCheck();
        });
    }

    reconfigureButton(size: WidgetSize){
        if(!this.settings.auto){
            return;
        }
        this.currentSize = size;
        switch (size){
            case WidgetSize.tiny:
                this.type = this.settings.smallMatType;
                this.text = "";
                break;
            case WidgetSize.small:
                this.type = this.settings.smallMatType;
                this.text = "";
                break;
            case WidgetSize.medium:
                this.type = this.settings.primaryMatType;
                this.text = this.settings.text;
                break;
            case WidgetSize.large:
                this.type = this.settings.primaryMatType;
                this.text = this.settings.text;
                break;
        }
        this._changeDetectorRef.markForCheck();
    }

    getColor(){
        return this.settings.color;
    }
}
